import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import TextArea from 'react-textarea-autosize';
import { handleChange } from 'utils/ComponentUtilFunctions';
import MessageEditControls from './MessageEditControls';
import config from "../../../../../config";


const styles = {
  wrapper: {
    backgroundColor: '#DDE4F6',
    padding: '12px 16px',
    borderRadius: '10px 10px 0px 10px',
    display: 'flex',
    alignItems: 'center',
  },
  textEdit: {
    width: '100%',
    border: 'none',
    background: 'transparent',
    resize: 'none',
  },
  text: {
    wordBreak: 'break-all',
    width: '100%',
  },
};

class TextMessageEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editing: false,
      currentValue: '',
      statuses: {}
    };

    this.handleChange = handleChange.bind(this);
  }

  handleEditIconClick = () => {
    const { value } = this.props;
    this.setState({
      editing: true,
      currentValue: value,
    });
  };

  handleCancel = () => {
    this.setState({
      editing: false,
      currentValue: '',
    });
  };

  handleSave = () => {
    const { updateMessage } = this.props;
    const { currentValue } = this.state;
    return updateMessage(currentValue).then(this.setState({
      editing: false,
      currentValue: '',
    }));
  };

  render() {
    const { editing, currentValue } = this.state;
    const { value, hardCodedMessagesStatusData, type, handleCheckboxChange } = this.props;

    if (type === config.hardCodedMessagesTypesMap.operatorJoinedText) {

    }

    let textView = editing ? <TextArea style={styles.textEdit} autoFocus onChange={this.handleChange('currentValue')} value={currentValue} /> : (
      <div style={styles.text}>
        {
          type === config.hardCodedMessagesTypesMap.operatorJoinedText
              ? "'Operator name' " + value
              : type === config.hardCodedMessagesTypesMap.outWorkingHoursText
                  ? value + " ('HH:mm' - 'HH:mm')"
                  : value
        }      </div>
    );

    return (
      <div style={styles.wrapper}>
        {textView}
        <label style={{marginRight: '10px', marginLeft: '10px'}} className="switch controller">
          <input
              type="checkbox"
              checked={hardCodedMessagesStatusData[type] ? hardCodedMessagesStatusData[type] : false}
              onChange={() => handleCheckboxChange(type)}
          />
          <span className="slider round"/>
        </label>
        <MessageEditControls
          editing={editing}
          handleEditIconClick={this.handleEditIconClick}
          handleCancel={this.handleCancel}
          handleSave={this.handleSave}
        />
      </div>
    );
  }
}

TextMessageEdit.propTypes = {
  value: PropTypes.string.isRequired,
  updateMessage: PropTypes.func.isRequired,
};

export default Radium(TextMessageEdit);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/TextMessageEdit.jsx